<div class="modal-header">
  <h4 class="modal-title">{{ modal_header }}</h4>
  <button class="btn-close" type="button" aria-label="Close" (click)="dismissModal()"></button>
</div>

<div class="modal-body py-0">
  <p>
    {{
      'termination_fee_warning'
        | translate: [asset.carrier_name ?? '', asset.contract_end_date ?? '']
    }}
  </p>

  <span class="fw-medium">{{ 'do_you_want_to_continue' | translate }}</span>
</div>

<div class="modal-footer border-top-0">
  <button class="btn btn-outline-secondary" type="button" (click)="dismissModal()">
    {{ 'cancel' | translate }}
  </button>
  <button class="btn btn-primary" type="button" (click)="continue()">
    {{ 'continue' | translate }}
  </button>
</div>
